/**
 * Backend experiment types
 */

// BackendExperiment includes both single-layer and multi-layer experiments.

// TODO: QS-6283 remove this field once scalable statsig layers are rolled out

/**
 * Frontend experiment types
 */

/**
 * Mutual exclusive experiment types
 */

export var Cohort = /*#__PURE__*/function (Cohort) {
  Cohort["Default"] = "not-enrolled";
  Cohort["Control"] = "control";
  Cohort["Test"] = "test";
  return Cohort;
}({});

/**
 * Side by side experiment types
 */

// Narrowed type where `type` is always 'experiment' or 'control'